import React from "react";


export default GoBackButton =>{
    return(
        <div className="my-9">
            <a href="" className="text-white">Go back</a>
        </div>
    )
}



